/**
 * Renders a prominent banner when the app is running in the staging environment.
 *
 * Controlled via the Vite env var:
 *   - VITE_APP_ENV=staging → banner is visible
 *   - any other value / undefined → banner is hidden
 */
export default function StagingBanner() {
  const isStaging = import.meta.env.VITE_APP_ENV === 'staging';

  if (!isStaging) return null;

  return (
    <div
      style={{
        backgroundColor: '#ffc107',
        color: '#212529',
        padding: '0.5rem 1rem',
        textAlign: 'center',
        fontWeight: 600,
        letterSpacing: '0.03em',
        fontSize: '0.9rem',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        zIndex: 1050,
      }}
    >
      STAGING ENVIRONMENT - Enterprise GitHub Pages Deployment
    </div>
  );
}
